import {
  CampaignCreatePageKey,
  CampaignListPageKey,
  CampaignListTableKey,
  CampaignReviewPageKey,
  ReferralAnalyticsKey,
  ReferralReportsKey,
  ReferralRewardModeKey,
  ReferralTierLadderKey
} from '../../TModules';

export const translations = {
  [CampaignListPageKey]: {
    Title: 'Kampagnen',
    Label: 'Neue erstellen'
  },

  [CampaignListTableKey]: {
    All: 'Alle',
    Draft: 'Entwurf',
    Pending: 'Ausstehend',
    Scheduled: 'Geplant',
    Active: 'Aktiv',
    Ended: 'Beendet',
    Inactive: 'Inaktiv',
    SearchPlaceholder: 'Kampagne nach Namen oder ID suchen',
    FilterBy: 'Filtern nach',

    // Game Types
    TapWin: 'Tippen & Gewinnen',
    CollectWin: 'Sammeln & Gewinnen',
    ShakeTheTree: 'Schüttel den Baum',
    HitThePinata: 'Triff die Piñata',
    SpinTheWheel: 'Dreh das Glücksrad',
    Plinko: 'Plinko',
    MysteryBox: 'Überraschungsbox',
    ScratchCard: 'Rubbellos',

    OnDeactivateErrorMessage: 'Fehler beim Deaktivieren der Kampagne',
    OnApproveErrorMessage: 'Fehler beim Genehmigen der Kampagne',
    OnMoveRowErrorMessage: 'Fehler beim Sortieren der Kampagne.',

    Approve: 'Genehmigen',
    Review: 'Überprüfen',
    Edit: 'Bearbeiten',
    Activate: 'Aktivieren',
    Deactivate: 'Deaktivieren',
    Duplicate: 'Duplizieren',
    UploadTries: 'Versuche hochladen',
    MoveToTop: 'Nach oben verschieben',
    ApproveCampaign: 'Kampagne genehmigen',

    Name: 'Name',
    Type: 'Typ',
    Status: 'Status',
    StartDate: 'Startdatum',
    EndDate: 'Enddatum',
    Request: 'Anfrage',
    Comments: 'Kommentare',
    Actions: 'Aktionen',
    AllGames: 'Alle Spiele',
    ApproveRequests: 'Anfragen genehmigen',

    ApproveMultipleMessageModal: {
      MultipleApproveRequestSuccessMessage: 'Anfragen wurden genehmigt',
      SuccessMessage: 'Kampagnen genehmigt',
      ErrorMessage: 'Fehler beim Genehmigen der Kampagnen.',
      Title: 'Mehrere Anfragen genehmigen?',
      OkText: 'Ausgewählte genehmigen',
      DescriptionLineOne:
        'Sind Sie sicher, dass Sie alle ausgewählten Anfragen genehmigen möchten?',
      DescriptionLineTwo:
        'Bitte überprüfen Sie die Details vor der Genehmigung, da diese Aktion nicht rückgängig gemacht werden kann.',
      ErrorApprovingRewards: 'Fehler beim Genehmigen der Belohnungen.'
    },

    ApproveMessageModal: {
      SuccessMessage: 'Anfrage wurde genehmigt',
      FailureMessage: 'Fehler beim Genehmigen der Kampagne.',
      Title: 'Kampagne genehmigen?',
      OkText: 'Genehmigen',
      DescriptionLineOne: 'Sind Sie sicher, dass Sie diese Kampagne genehmigen möchten?',
      DescriptionLineTwo: 'Diese Aktion kann nicht rückgängig gemacht werden.'
    },

    CampaignType: {
      AllCampaigns: 'Alle Kampagnen',
      InstantReward: 'Sofortbelohnung',
      Stamp: 'Stempel',
      Referral: 'Referral',
      Game: 'Spiel',
      Reward: 'Belohnung',
      Quiz: 'Quiz',
      Survey: 'Umfrage',
      Quest: 'Quest',
      Progress: 'Fortschritt',
      Raffle: 'Gewinnspiel',
      MultipleRuleCampaign: 'Mehrfachregelkampagne'
    }
  },

  [CampaignCreatePageKey]: {
    DuplicatingCampaign: 'Kampagne wird dupliziert...',
    OnSubmitErrorMessage: 'Keine Änderungen erkannt',
    StreakModeIsRequired: 'Serienmodus ist erforderlich',
    StreakTargetIsRequired: 'Serienziel ist erforderlich',
    StreakTargetCriteriaIsRequired: 'Kriterien für das Serienziel sind erforderlich',
    StreakDurationIsRequired: 'Seriendauer ist erforderlich',
    Steps: {
      TaskType: 'Aufgabentyp',
      Back: 'Zurück',
      Cancel: 'Abbrechen',
      Next: 'Weiter',
      SaveAsDraft: 'Als Entwurf speichern',
      Publish: 'Veröffentlichen',
      Save: 'Speichern',
      Deactivate: 'Deaktivieren',
      Schedule: 'Planen',

      Info: 'Info',
      SelectAudience: 'Zielgruppe auswählen',
      Mechanics: 'Mechanik',
      StreakMode: 'Serienmodus',
      StreakTargetAndPrizes: 'Serienziel und Preise',
      Review: 'Überprüfung',
      DetailedTitle: {
        Info: 'Kampagnen-Info',
        SelectAudience: 'Zielgruppe auswählen',
        Mechanics: 'Mechanik',
        Review: 'Überprüfung'
      },
      ViewInsights: 'Insights ansehen',
      Edit: 'Bearbeiten',
      Loading: 'Laden'
    },

    CampaignInfo: {
      Title: 'Kampagnendetails',
      Form: {
        Name: 'Name',
        NamePlaceholder: 'Bitte geben Sie Ihren Kampagnennamen ein',
        Subtitle: 'Untertitel',
        SubtitlePlaceholder: 'Bitte geben Sie Ihren Kampagnenuntertitel ein',
        ContentSuggestions: 'Inhaltsvorschläge',
        ShowChatGPTForm: {
          TooltipTitle:
            'Token-Limits werden täglich erneuert. Werden Sie Perx-Exklusivmitglied für unbegrenzte Tokens',
          TokensLeft: 'Token übrig'
        },
        Description: 'Beschreibung',
        TermsAndConditions: 'Allgemeine Geschäftsbedingungen',
        RiskDisclaimer: 'Risikohinweis',

        CampaignDuration: 'Kampagnendauer',
        StartDate: 'Startdatum',
        EndDate: 'Enddatum',
        EarlyDisplayCampaign: 'Kampagne früher anzeigen',
        DaysBeforeStartDate: 'Tage vor dem Startdatum',
        DaysBeforeTheStartDate: 'Tage vor dem Startdatum',
        CampaignDoesNotEnd: 'Kampagne endet nicht',
        ShouldHideDurationEndDateAlertMessage: 'Gewinnspielkampagnen benötigen ein Enddatum',
        EndDateAlertMessage: 'Das Enddatum muss am oder nach dem Startdatum liegen',

        Reset: 'Zurücksetzen',
        OCBCDemo: {
          Never: 'Nie',
          Weekly: 'Wöchentlich',
          Monthly: 'Monatlich',
          Yearly: 'Jährlich'
        },

        ActiveAt: 'Aktiv ab',
        ActiveAtMessage: 'Kampagne aktiviert sich nicht vor dem Startdatum',

        Tags: 'Tags',
        Categories: 'Kategorien',
        Labels: 'Labels',
        Catalogues: 'Kataloge',
        Owner: 'Besitzer',
        PleaseSelectAnOwner: 'Bitte wählen Sie einen Besitzer',

        UploadPhoto: 'Foto hochladen',
        UploadMultipleImages: 'Mehrere Bilder hochladen',
        Merchant: 'Händler',
        MerchantSelectPlaceholder: 'Bitte wählen Sie einen Händler',
        Locations: 'Standorte',
        LocationsSelectPlaceholder: 'Bitte wählen Sie Standorte',
        CustomFields: 'Benutzerdefinierte Felder',
        CustomField: 'Benutzerdefiniertes Feld',
        CustomFieldNamePlaceholder: 'Bitte geben Sie den Feldnamen ein',
        CustomFieldValuePlaceholder: 'Bitte geben Sie den Feldwert ein',
        AddCustomField: 'Benutzerdefiniertes Feld hinzufügen'
      },

      TagSelect: 'Bitte wählen Sie Ihre Tags',
      CategorySelect: 'Bitte wählen Sie Ihre Kategorien',
      LabelSelect: 'Bitte wählen Sie Ihre Labels',
      CatalogueSelect: 'Bitte wählen Sie Ihre Kataloge'
    },

    ButtonWithImageUpload: {
      Cancel: 'Abbrechen',
      InsertPhoto: 'Foto einfügen',
      UploadFile: 'Datei hochladen',
      ChooseFile: 'Datei auswählen',
      ChooseAFile: 'Datei auswählen',
      SelectPngSvgJpegGif: 'PNG, SVG, JPEG oder GIF auswählen'
    },

    CampaignSelectAudience: {
      SelectAudience: 'Zielgruppe auswählen',
      DefaultAudience: 'Erstellen Sie eine einmalige Zielgruppe für diese Kampagne',
      ExistingAudience: 'Wählen Sie eine vorhandene Zielgruppe',
      AudienceSetup: 'Zielgruppen-Einstellungen',
      SelectFilters: 'Filter auswählen',
      SelectedFilters: 'Ausgewählte Filter',

      AudienceListSetup: {
        Include: 'Einschließen',
        Exclude: 'Ausschließen',
        AudienceExistsMessage: `Kann {{audienceIncludeExclude}} Zielgruppe nicht erstellen, die bereits für {{audienceIncludeExcludeNoun}} festgelegt ist`,
        PickAudienceList: 'Zielgruppen-Liste auswählen',

        Includes: 'Einschließen',
        Excludes: 'Ausschließen',
        AudienceWarningMessage:
          'Die hochgeladene Zielgruppendatei wird nur verarbeitet, wenn sie von einem Bulk Actions Approver genehmigt wurde',
        SelectedFileForInclusion: 'Ausgewählte Datei für Einschließen',
        AudienceNotInTheList: 'Zielgruppe nicht in der Liste',
        IncludeAudienceFilenamePlaceholder: 'Name der Einschließungs-Zielgruppe',
        UploadNow: 'Jetzt hochladen',
        UploadNewList: 'Neue Liste hochladen',
        AcceptedFormat: 'Format akzeptiert: nur .xlsx/.csv-Dateien.',
        DownloadSample: 'Beispiel herunterladen',
        UploadExclusion: 'Ausschließen hochladen',
        SelectedFileForExclusion: 'Ausgewählte Datei für Ausschluss',
        ExcludeAudienceFilenamePlaceholder: 'Name der Ausschluss-Zielgruppe'
      },

      AudienceFilters: {
        Age: 'Alter',
        BirthMonth: 'Geburtsmonat',
        Gender: 'Geschlecht',
        Location: 'Standort',
        Loyalty: 'Treue',
        Personal: 'Persönlich',
        Custom: 'Benutzerdefiniert',
        EmailTags: 'Email-Tags',
        Ethnicity: 'Ethnie',
        SelectCustomerAttributeFilters: 'Wählen Sie Ihre Kundenattribute-Filter:',
        NoFiltersSelected: 'Keine Filter ausgewählt',
        And: 'und',
        Badge: 'Badge',
        Campaign: 'Kampagne',
        Leaderboard: 'Leaderboard',
        LoyaltyPoints: 'Loyalty Punkte',
        LoyaltyTier: 'Loyalty-Tier',
        MemberSince: 'Mitglied seit',
        Reward: 'Belohnung',
        PaymentBased: 'Zahlung basiert',
        Payment: 'Zahlung',
        SelectFilters: 'Filter auswählen, um eine Zielgruppenliste automatisch zu generieren',
        City: 'Stadt',
        States: 'Bundesländer',

        OfferId: 'Angebot ID',
        PrimaryClusterComb: 'Primärer Cluster-Kombination',
        PrimaryClusterState: 'Primärer Cluster-Status',
        Membership: 'Mitglied von',
        CurrentBirthday: 'Nur während des Geburtstags',
        CurrentBirthMonth: 'Nur während des Geburtsmonats',
        HasBirthday: 'Am Geburtstag',
        UserType: 'Benutzer-Typ',
        AccountConfirmedAt: 'Registriert zwischen',
        LoyaltyPointsBalance: 'Punkte-Saldo',
        CampaignEnrolment: 'Kampagne',
        LeaderboardPosition: 'Bestenlisten-Position',
        UPI: 'UPI',
        ScanPay: 'Scan-Zahlung',
        BBPS: 'BBPS',
        KYC: 'KYC',
        CurrentAddress: 'Aktueller Standort',
        PaymentStatus: 'Zahlungsstatus',
        DaysPastDues: 'Tage überfällig',
        BNPLUnpaidEMIDate: 'BNPL unbezahltes EMI-Datum',
        InstaloanUnpaidEMIDate: 'Ratenkredit unbezahltes EMI-Datum',

        AgeFilter: {
          Title: 'Alter',
          Includes: 'Einschließen',
          Excludes: 'Ausschließen',
          SelectPlaceholder: 'Einschließen',
          From: 'Alter von',
          FromPlaceholder: '18',
          To: 'bis',
          ToPlaceholder: '35',
          AddRange: 'Bereich hinzufügen',
          And: 'und'
        },
        BirthdayFilter: {
          Title: 'Geburtstag',
          SelectBirthMonth: 'Geburtsmonat auswählen',
          BirthMonth: 'Geburtsmonat',
          CurrentBirthMonth: 'Aktueller Geburtsmonat',
          OnlyDuringMonthOfBirth: 'Nur während des Geburtsmonats',
          HasBirthday: 'Geburtstag hat',
          OnBirthday: 'Am Geburtstag',
          Includes: 'Einschließen',
          Excludes: 'Ausschließen'
        },

        GenderFilter: {
          Title: 'Geschlecht',
          SelectByGender: 'Geschlecht auswählen',
          Male: 'Männlich',
          Female: 'Weiblich'
        },

        EthnicityFilter: {
          Title: 'Ethnie',
          SelectEthnicity: 'Ethnie auswählen',
          SelectEthnicityPlaceholder: 'Ethnie auswählen',
          Include: 'Einschließen',
          Exclude: 'Ausschließen',
          Includes: 'Einschließen',
          Excludes: 'Ausschließen'
        },

        LocationFilter: {
          Title: 'Standort',
          SelectCity: 'Städte auswählen',
          Include: 'Einschließen',
          Exclude: 'Ausschließen',
          SelectCityPlaceholder: 'Städte auswählen',
          SelectState: 'Bundesland auswählen',
          SelectStatePlaceholder: 'Bundesland auswählen',
          Includes: 'Einschließen',
          Excludes: 'Ausschließen'
        },

        PersonalFilter: {
          Title: 'Persönlich',
          HubClub: 'Hub-Club',
          Select: 'Auswählen',
          Include: 'Einschließen',
          Exclude: 'Ausschließen',
          AddCustomProperties: 'Benutzerdefinierte Eigenschaften hinzufügen',

          EnterKeyNameAndValueDetails: 'Schlüsselname und Wertdetails eingeben',
          SelectRelation: 'Beziehung auswählen',
          EnterNumber: 'Zahl eingeben',
          KeyValue: 'Schlüsselwert',
          DatePlaceholder: 'TT.MM.JJJJ',
          KeyNamePlaceholder: 'Schlüsselname',
          Is: 'Ist',
          True: 'Wahr',
          False: 'Falsch',
          And: 'UND',
          Or: 'ODER',
          CustomAttributeType: 'Benutzerdefiniertes Attribut-Typ #{{index}}',
          CustomAttribute: 'Benutzerdefiniertes Attribut #{{index}}',
          CustomAttributeOperator: 'Benutzerdefiniertes Attribut-Operator #{{index}}',
          CustomAttributeValue: 'Benutzerdefiniertes Attribut-Wert #{{index}}'
        },
        LoyaltyFilter: {
          Title: 'Treue',
          SelectLoyaltyProgram: 'Treue-Programm auswählen',
          Include: 'Einschließen',
          Exclude: 'Ausschließen',
          SelectProgram: 'Programm auswählen',
          Includes: 'Einschließen',
          Excludes: 'Ausschließen',
          UsersWithPointsBalance: 'Benutzer mit Punkt-Saldo',
          SelectLoyaltyProgramPlaceholder: 'Treue-Programm auswählen',
          From: 'Von',
          To: 'Bis',
          PointsBalanceFrom: 'Punkt-Saldo von',
          PointsBalanceTo: 'Bis'
        },

        EmailTagsFilter: {
          Includes: 'Einschließen',
          SelectEmailTags: 'Email-Tags auswählen',
          Excludes: 'Ausschließen'
        }
      }
    },

    SocialMediaFields: {
      Title: 'Soziale Medien',
      OGTitle: 'Titel',
      OGDescription: 'Beschreibung',
      OGImage: 'Bild',
      OGImageAlt: 'Soziale Medien-Überprüfung',
      IOSAppLink: 'iOS App-Link',
      AndroidAppLink: 'Android App-Link',
      WebLink: 'Web-Link',
      EitherAnIOSOrAndroidOrWebLinkIsRequired: 'Eine iOS-, Android- oder Web-Link ist erforderlich',
      Allowed: 'Erlaubt: .jpg, .png, .svg',
      Browse: 'Durchsuchen',
      Recommended: 'Empfohlen: 720px by 120px'
    },

    CampaignMechanics: {
      CampaignType: 'Kampagne-Typ',
      InstantReward: 'Sofortbelohnung',
      MultipleRuleCampaign: 'Mehrfachregelkampagne',
      Reward: 'Belohnung',
      Progress: 'Fortschritt',
      Raffle: 'Gewinnspiel',
      Stamp: 'Stempel',
      Game: 'Spiel',
      Quest: 'Quest',
      Referral: 'Referral',
      Survey: 'Umfrage',
      Quiz: 'Quiz',
      Streak: 'Serie',
      GameTry: 'Spiel versuchen',
      Day: 'Tag',
      GiveRewardTitle: 'Sofort alle Belohnungen ausgeben',
      Yes: 'Ja',
      No: 'Nein'
    },

    CampaignReferralGameTryModal: {
      SelectCampaigns: 'Kampagnen auswählen',
      SetupReferralRule: 'Empfehlungsregel einrichten',
      NumberOfGameTry: 'Anzahl der Spielversuche',
      WarningText:
        'Nur Kampagnen mit deaktivierter automatischer Spielversuchausgabe können für die Ausgabe von Spielversuchen ausgewählt werden.',
      CampaignID: 'Kampagnen-ID: {{id}}, {{name}}',
      Back: 'Zurück',
      Next: 'Weiter',
      Done: 'Fertig',
      SearchCampaigns: 'Kampagnen suchen',
      Active: 'Aktiv',
      Scheduled: 'Geplant',
      Referee: 'Geworbener',
      Referrer: 'Werber',
      NoOfReferralsNeeded: 'Anzahl der benötigten Empfehlungen'
    },

    Outcomes: {
      SelectOutcomes: 'Belohnungen auswählen',
      Name: 'Name',
      Action: 'Aktion',
      EditPoints: 'Punkte bearbeiten',
      Remove: 'Entfernen',
      EditReferralRule: 'Referral-Regel bearbeiten',
      MoveToTop: 'Nach oben verschieben',
      MerchantName: 'Händler Name',
      SellingFrom: 'Verkauf startet am',
      SellingTo: 'Verkauf endet am',
      RewardBalance: 'Belohnungssaldo',
      PointsAwarded: 'Punkte vergeben',
      ReferrerLimits: 'Referrer-Limits',
      ReferralsNeeded: 'Referrals benötigt',
      RefereeRewardLimit: 'Referee-Belohnungssaldo',
      AwardBadges: 'Belohnungen auswählen',
      AwardPoints: 'Punkte vergeben',
      AddRewards: 'Belohnungen hinzufügen',
      AwardGameTry: 'Spielversuch vergeben',
      EditGameTry: 'Spielversuch bearbeiten',
      ReferrerGameTryIssued: 'Spielversuch Werber ausgegeben',
      RefereeGameTryIssued: 'Spielversuch Geworbener ausgegeben'
    },

    CampaignRules: {
      AddRule: 'Regel hinzufügen'
    },

    RefferalSelectionModal: {
      Title: 'Referral-Regel bearbeiten',
      OnCancelError: 'Referral-Wert ist keine Zahl! Bitte überprüfen Sie es!',
      OkButtonText: 'OK',
      RewardId: 'Belohnung ID:',
      Referee: 'Referee',
      Referrer: 'Referrer',
      NoOfReferralsNeeded: 'Anzahl der Referrals benötigt',
      TotalRewardLimit: 'Gesamte Belohnungssaldo',
      RewardLimit: 'Belohnungssaldo',
      RewardBalance: 'Belohnungssaldo : ',
      CheckboxError: 'Referrer oder Referee-Optionen sind erforderlich',
      RewardIDTitle: 'Belohnung ID:',
      Points: 'Punkte',
      Of: ' von ',
      TotalOutcomeLimit: 'Gesamte Belohnungssaldo',
      OutcomeLimit: 'Belohnungssaldo',
      NumberError: 'Diese Wert muss eine Zahl sein',
      RequiredError: 'Dieser Wert ist erforderlich'
    },

    CampaignReferralRewardPickerModal: {
      SearchRewards: 'Belohnungen suchen',
      Active: 'Aktiv',
      Private: 'Privat',
      Approved: 'Genehmigt',
      System: 'System',
      SelectRewards: 'Belohnungen auswählen',
      Back: 'Zurück',
      Next: 'Weiter',
      Done: 'Fertig',
      Name: 'Name',
      MerchantName: 'Händler Name',
      SellingFrom: 'Verkauf startet am',
      SellingTo: 'Verkauf endet am',
      RewardBalance: 'Belohnungssaldo',
      SetupReferralRule: 'Referral-Regel einrichten'
    },

    RewardPicker: {
      SelectRewards: 'Belohnungen auswählen',
      OkButtonText: 'Belohnungen hinzufügen',
      SearchRewards: 'Finde eine neue Belohnung nach Name, Typ oder Händler',
      Active: 'Aktiv',
      Private: 'Privat',
      Approved: 'Genehmigt',
      System: 'System',
      Ended: 'Beendet',
      Inactive: 'Inaktiv',
      Draft: 'Entwurf',
      Name: 'Name',
      MerchantName: 'Händler Name',
      SellingFrom: 'Verkauf startet am',
      SellingTo: 'Verkauf endet am',
      RewardBalance: 'Belohnungssaldo'
    },

    CampaignReferralPointsModal: {
      PleaseSelectGLAccount: 'Bitte wählen Sie einen GL-Konto',
      PleaseSelectGLAccountTypeAndName: 'Bitte wählen Sie ein GL-Konto, Typ und Name',
      PleaseSetNumberOfPointsToAward: 'Bitte setzen Sie die Anzahl der zu vergebenden Punkte',
      SetPointsToAward: 'Punkte setzen',
      Next: 'Weiter',
      Done: 'Fertig',
      SelectLoyaltyProgram: 'Treue-Programm auswählen',
      HowManyPoints: 'Wie viele Punkte?',
      SelectGLAccount: 'GL-Konto auswählen',
      SelectGLAccountType: 'GL-Konto-Typ auswählen',
      SelectGLAccountName: 'GL-Konto-Name auswählen',
      SelectGLAccountNamePlaceholder: 'Name',
      EnterPoints: 'Punkte eingeben',
      SetupReferralRule: 'Referral-Regel einrichten'
    },

    GameTypesSelectModal: {
      Title: 'Wähle einen Spieltyp',
      OkButtonText: 'Auswählen',
      CancelButtonText: 'Abbrechen',

      ShakeTheTree: {
        Title: 'Schüttel den Baum',
        InstructionsLineOne:
          'Binde Kunden mit einer Herausforderung ein, bei der sie das Telefon schütteln müssen',
        InstructionsLineTwo: 'Spielmechanik',
        InstructionsLineThree:
          '1. Der Endbenutzer erhält eine Belohnung basierend auf der Ausführung einer erforderlichen Aktion, in diesem Fall durch Schütteln des Baums',
        InstructionsLineFour:
          '2. Belohnungen werden zufällig basierend auf der für die Belohnungen festgelegten Wahrscheinlichkeit vergeben',
        InstructionsLineFive: 'Ideal für',
        InstructionsLineSix: '1. Saisonales Spiel'
      },
      HitThePinata: {
        Title: 'Triff die Piñata',
        InstructionsLineOne:
          'Binde Kunden mit einer Herausforderung ein, bei der sie die Piñata treffen müssen',
        InstructionsLineTwo: 'Spielmechanik',
        InstructionsLineThree:
          '1. Der Endbenutzer erhält eine Belohnung basierend auf der Ausführung einer erforderlichen Aktion, in diesem Fall durch Treffen der Piñata',
        InstructionsLineFour:
          '2. Belohnungen werden zufällig basierend auf der für die Belohnungen festgelegten Wahrscheinlichkeit vergeben',
        InstructionsLineFive: 'Ideal für',
        InstructionsLineSix: '1. Saisonales Spiel'
      },
      ScratchCard: {
        Title: 'Rubbelkarte',
        InstructionsLineOne:
          'Binde Kunden ein, indem sie rubbeln und aufregende Preise gewinnen können',
        InstructionsLineTwo: 'Spielmechanik',
        InstructionsLineThree:
          '1. Der Endbenutzer erhält eine Belohnung basierend auf der Ausführung einer erforderlichen Aktion, in diesem Fall durch Rubbeln der Karte',
        InstructionsLineFour:
          '2. Belohnungen werden zufällig basierend auf der für die Belohnungen festgelegten Wahrscheinlichkeit vergeben',
        InstructionsLineFive: 'Ideal für',
        InstructionsLineSix: '1. Saisonales Spiel'
      },
      SpinTheWheel: {
        Title: 'Dreh das Rad',
        InstructionsLineOne:
          'Binde Kunden ein, indem sie das Rad drehen und aufregende Preise gewinnen können',
        InstructionsLineTwo: 'Spielmechanik',
        InstructionsLineThree:
          '1. Der Endbenutzer erhält eine Belohnung basierend auf der Ausführung einer erforderlichen Aktion, in diesem Fall durch Drehen des Rads',
        InstructionsLineFour:
          '2. Belohnungen werden zufällig basierend auf der für die Belohnungen festgelegten Wahrscheinlichkeit vergeben',
        InstructionsLineFive: 'Ideal für',
        InstructionsLineSix: '1. Saisonales Spiel'
      },
      Plinko: {
        Title: 'Plinko',
        InstructionsLineOne:
          'Binde Kunden ein, indem sie ihr Glück versuchen, den Ball in das Gewinnfeld zu bekommen',
        InstructionsLineTwo: 'Spielmechanik',
        InstructionsLineThree:
          '1. Der Endbenutzer erhält eine Belohnung basierend auf der Ausführung einer erforderlichen Aktion, in diesem Fall durch Fallenlassen des Balls',
        InstructionsLineFour:
          '2. Belohnungen werden zufällig basierend auf der für die Belohnungen festgelegten Wahrscheinlichkeit vergeben',
        InstructionsLineFive: 'Ideal für',
        InstructionsLineSix: '1. Saisonales Spiel'
      }
    },

    StreakTypesSelectModal: {
      SelectStreakCampaignType: 'Streak-Kampagnentyp auswählen',
      ContinuousLoop: 'Kontinuierliche Schleife',
      MilestoneBased: 'Meilensteinbasiert',
      TransactionCount: 'Transaktionsanzahl',
      Progressive: 'Progressiv',
      CheckIn: 'Check-in',
      CumulativeSpend: 'Kumulierte Ausgaben',
      ContinuousLoopDescription:
        'Halten Sie Kunden engagiert, indem sie Aufgaben wiederholt innerhalb eines festen Zeitraums ausführen und jedes Mal eine Belohnung erhalten.',
      GameMechanicsTitle: 'Spielmechanik',
      ContinuousLoopGameMechanicsLineOne:
        '1. Das Spiel hat einen festen Zeitraum – täglich, wöchentlich oder monatlich.',
      ContinuousLoopGameMechanicsLineTwo:
        '2. Benutzer müssen eine bestimmte Aufgabe mehrmals innerhalb des Zeitraums ausführen. Wenn sie alle Aufgaben abgeschlossen haben, erhalten sie eine Belohnung, und die Kampagne startet automatisch in der nächsten Periode neu.',
      IfCustomersMissAStreakTheyStartAgainAtTheNextStreakPeriod:
        '3. Wenn Kunden eine Serie verpassen, beginnen sie im nächsten Serienzeitraum erneut.',
      ContinuousLoopIdealForTitle: 'Ideal für',
      ContinuousLoopIdealForLineOne: '1. Tägliche Check-in-Kampagnen',

      MilestoneBasedDescription:
        'Setzen Sie progressive Ziele für Ihre Kunden, um wiederholte Aufgaben auszuführen, mit einer Belohnung für jeden erreichten Meilenstein.',
      MilestoneBasedGameMechanicsTitle: 'Spielmechanik',
      MilestoneBasedGameMechanicsLineOne:
        '1. Das Spiel hat ein festes Intervall – täglich, wöchentlich oder monatlich.',
      MilestoneBasedGameMechanicsLineTwo:
        '2. Das Spiel erfordert eine definierte Aufgabe, die wiederholt ausgeführt werden muss – z. B. Anmeldung, bestimmte Transaktion usw.',
      MilestoneBasedGameMechanicsLineThree:
        '3. Definieren Sie Meilensteine basierend darauf, wie viele Aufgaben und über wie viele aufeinanderfolgende Perioden sie ausgeführt werden müssen.',
      MilestoneBasedGameMechanicsLineFour:
        '4. Kunden erhalten eine Belohnung, wenn sie den Meilenstein erreichen. Wenn sie eine Serie verpassen, beginnen sie erneut beim aktuellen Meilenstein. Belohnungen werden nur einmal pro Meilenstein vergeben.'
    },

    TeamsMechanics: {
      Title: 'Team-Mechanik',
      Description:
        'Team-Mechanik-Einstellungen können nach Veröffentlichung einer Kampagne nicht mehr aktualisiert werden.',
      ActivateTeamMechanics: 'Team-Mechanik aktivieren',
      TeamSize: 'Benutzer pro Team',
      LandingScreen: 'Startbildschirm',
      Image: 'Bild',
      ImageHelpText: 'Mindestgröße 360(B) x 144(H) px in jpg oder png',
      PreEnrollmentMessage: 'Voranmeldungsnachricht',
      StampsEarnMessage: 'Stempel-Sammelnachricht',
      GameplayInstructions: 'Spielanleitung',
      JoinTeamPage: 'Team beitreten Seite',
      JoinTeamInfoMessage: 'Team beitreten Info-Nachricht',
      InviteMemberMessage: 'Mitglied einladen Nachricht',
      InviteCodeBlurb: 'Einladungscode Text',
      CharactersUsed: 'Verwendete Zeichen',
      Note: 'Hinweis',
      NoteDescriptionOne: 'Sowohl die',
      NoteDescriptionTwo: 'Mitglied einladen Nachricht',
      NoteDescriptionThree: 'als auch der',
      NoteDescriptionFour: 'Einladungscode Text',
      NoteDescriptionFive:
        'werden verwendet, um die "Teilen-Nachricht" zu generieren. Wir haben keine Beschränkung für die Länge dieser Nachricht festgelegt - beachten Sie jedoch, dass SMS-Nachrichten auf 160 Zeichen pro Nachricht begrenzt sind',

      DefaultPreEnrollmentMessagePartOne:
        'Erstellen oder treten Sie einem {{teamSize}}-Personen-Team bei',
      DefaultPreEnrollmentMessagePartTwo: 'Sie können 1 Team erstellen oder einem beitreten.',
      DefaultStampsEarnMessagePartOne: 'Sammeln Sie Stempel durch folgende Aktivitäten',
      DefaultStampsEarnMessagePartTwo: 'KYC durchführen',
      DefaultStampsEarnMessagePartThree: 'Auf E-Statements umstellen',
      DefaultParticipationInfoMessagePartOne:
        'Verdienen Sie Belohnungen durch folgende Aktivitäten',
      DefaultParticipationInfoMessagePartTwo: 'KYC durchführen',
      DefaultParticipationInfoMessagePartThree: 'Auf E-Statements umstellen',
      DefaultTeamCompleteButtonText: 'Ihren Fortschritt prüfen',
      DefaultTeamCompleteButtonTextStamp: 'Ihre Stempelkarten ansehen',
      DefaultTeamIncompleteButtonText: 'Einem Team beitreten',
      DefaultTeamIncompleteButtonTextSecondary: 'Ein Team erstellen',
      DefaultJoinTeamPageDescriptionPartOne:
        'Ein Team gilt erst als aktiv, wenn {{teamSize}} Mitglieder beigetreten sind.',
      DefaultJoinTeamPageDescriptionPartTwo:
        'Geben Sie den Code/URL im obigen Feld ein und klicken Sie auf Beitreten',
      DefaultJoinTeamPageDescriptionPartThree:
        'Warten Sie, bis {{teamSize}} Mitglieder beigetreten sind',
      DefaultJoinTeamPageDescriptionPartFour: 'Sammeln Sie Stempel als Team',
      DefaultJoinTeamPageDescriptionPartFive: 'Spielen Sie Spiele als Team',
      DefaultJoinTeamPageDescriptionPartSix:
        'Einzelpersonen können nur Teil von 1 Team sein (egal ob erstellt oder beigetreten)',
      DefaultInviteMessageDescriptionPartOne: 'Hallo, bitte tritt meinem Team bei, um',
      DefaultInviteMessageDescriptionPartTwo: ' Stempelkarten auszufüllen ',
      DefaultInviteMessageDescriptionPartThree: ' Spiele zu spielen ',
      DefaultInviteMessageDescriptionPartFour: ' und gemeinsam Preise zu gewinnen!',
      DefaultInviteMessageCodeBlurb: 'Nutze meinen Team-Code:'
    },

    EnrolMechanics: {
      EnrolmentMechanics: 'Anmelde-Mechanik',
      AutoEnrolUsers: 'Benutzer automatisch anmelden',
      EnrollableUntil: 'Anmeldbar bis',
      AutoFillStamps: 'Stempel automatisch ausfüllen',
      EnableCampaignDurationMechanics: 'Kampagnendauer-Mechanik aktivieren',
      UsersMustCompleteTheCampaignWithin: 'Benutzer müssen die Kampagne abschließen innerhalb von',
      AutoRedeemOutcome: 'Ergebnis automatisch einlösen',
      Yes: 'Ja',
      No: 'Nein'
    },

    StreakMechanics: {
      StreakMechanics: 'Serienmechanik',
      SelectTaskType: 'Aufgabentyp auswählen',
      CumulativeSpend: 'Kumulierte Ausgaben',
      TransactionCount: 'Transaktionsanzahl',
      SignIn: 'Anmelden',
      StreakRequirements: 'Serienanforderungen',
      TargetCriteria: 'Zielkriterien',
      UserMustPerformTheTask: 'Der Benutzer muss die Aufgabe ausführen',
      TimesWithinOne: 'Mal innerhalb von 1',
      StreakTarget: 'Serienziels',
      Continuous: 'aufeinanderfolgende',
      Days: 'Tage',
      Weeks: 'Wochen',
      Months: 'Monate',
      SelectTrigger: 'Auslöser auswählen',
      MilestonesAndPrizes: 'Meilensteine und Preise',
      TargetMake: 'Ziel: Durchführen',
      ValidTransactionsEvery: 'gültige Transaktionen alle',
      For: 'für',
      Level: 'Ebene',
      MustBeMoreThanLevel: 'muss höher als Ebene sein',
      SelectStreakDuration: 'Seriendauer auswählen',
      Daily: 'Täglich',
      Weekly: 'Wöchentlich',
      Monthly: 'Monatlich',
      AtLeastOneConditionIsRequired: 'Mindestens eine Bedingung ist erforderlich',
      CustomerSignIn: 'Kundenanmeldung',
      TransactionCreated: 'Transaktion erstellt',
      TargetSpend: 'Ziel: Ausgaben',
      CurrencyEvery: 'Währung alle',
      TargetSignIn: 'Ziel: Anmeldung',
      TimesEvery: 'Mal alle',
      Perform: 'ausführen',
      Signin: 'anmelden',
      Transaction: 'Transaktion',
      Spend: 'ausgeben',
      PerformTheTask: 'die Aufgabe ausführen',
      InOrderToWinThePrize: 'um den Preis zu gewinnen',
      MakeTransactionAtLeast: 'Transaktion mindestens durchführen',
      Times: 'Mal',
      AtLeast: 'mindestens',
      Where: 'wo',
      CurrencyOnTransactionsWhere: 'Währung, bei Transaktionen, bei denen',
      MakeTransaction: 'Transaktion durchführen'
    },

    LandingPage: {
      Title: 'Startseite',
      Headline: 'Überschrift',
      SubHeadline: 'Unterüberschrift',
      BodyText: 'Text',
      Image: 'Bild',
      CTAButtonText: 'CTA Button Text',
      CTAButtonColour: 'CTA Button Farbe',
      CTAButtonTextColour: 'CTA Button Text Farbe',
      TermsAndConditions: 'AGB'
    },

    StampCampaign: {
      Config: {
        Title: 'Anzahl der Stempel auswählen',
        TotalStampsOnCard: 'Gesamtzahl der Stempel auf der Karte',
        TotalStamps: 'Gesamtzahl der Stempel',
        StampsPerRow: 'Anzahl der Stempel pro Reihe (max. 5)',
        StampsPerRowPlaceholder: '(Optional) Stempel pro Reihe angeben',
        StampsPerColumn: 'Anzahl der Stempel pro Spalte',
        StampsPerColumnPlaceholder: '(Optional) Stempel pro Spalte angeben'
      },
      TriggerConfig: {
        Title: 'Stempel-Sammelregeln festlegen'
      },
      CardBackground: {
        Title: 'Kartenbild',
        HeaderMessage: 'Überschrift',
        Subheadline: 'Unterüberschrift',
        Backgrounds: 'Hintergründe',
        BackgroundImage: 'Hintergrundbild',
        RemoveImage: 'Bild entfernen',
        BrowseFiles: 'DATEIEN DURCHSUCHEN',
        CardBackgroundImage: 'Karten-Hintergrundbild',
        CardBackgroundImageAlt: 'Stempelkarten-Hintergrund',
        ThumbnailImage: 'Vorschaubild',
        ThumbnailImageAlt: 'Stempel-Vorschau',
        Elements: 'Elemente',
        GiftActive: 'Geschenk (Aktiv)',
        GiftActiveAlt: 'Geschenk',
        GiftInactive: 'Geschenk (Inaktiv)',
        GiftInactiveAlt: 'Geschenk (Inaktiv)',
        StampActive: 'Stempel (Aktiv)',
        StampActiveAlt: 'Stempel',
        StampInactive: 'Stempel (Inaktiv)',
        StampInactiveAlt: 'Stempel (Inaktiv)',
        ButtonText: 'Button-Text',
        ButtonExternalLink: 'Externer Button-Link',
        ButtonColour: 'Button-Farbe',
        ButtonTextColour: 'Button-Textfarbe'
      },
      LimitConfig: {
        Title: 'Stempel-Limits',
        TotalStampCards: 'Gesamtzahl Stempelkarten',
        TotalStampCardsPerUser: 'Stempelkarten pro Benutzer',
        TotalStamps: 'Gesamtzahl Stempel',
        TotalStampsPerUser: 'Stempel pro Benutzer',
        Every: 'alle',
        Days: 'Tage',
        Months: 'Monate',
        Year: 'Jahr',
        Weeks: 'Wochen'
      }
    },

    Referral: {
      Title: 'Referral-Code-Typen',
      CodeType: 'Code-Typ',
      ReferredBy: 'Referral-von',
      SelectFile: 'Datei auswählen',
      SystemGenerated: 'System generiert',
      AlternateId: 'Alternativer ID',
      User: 'Benutzer',
      Partner: 'Partner',
      ActionMechanics: 'Aktion-Mechanik',

      UploadSingleFileFiled: {
        AcceptedFormat: 'Akzeptierte Formate: {{acceptedFormatsString}} Dateien nur',
        DownloadSample: 'Beispiel herunterladen',
        ChooseFile: 'Datei auswählen'
      }
    },

    CampaignRulesTable: {
      Name: 'Name',
      CampaignPointsIssued: 'Kampagne-Punkte ausgegeben',
      Action: 'Aktion',
      Edit: 'Bearbeiten',
      Remove: 'Entfernen'
    }
  },

  [CampaignReviewPageKey]: {
    GameInfoTitle: 'Spielinfo',

    GameInfo: {
      NumberOfTaps: 'Anzahl der Tipper:',
      NumberOfGiftsShown: 'Anzahl der Geschenk-Icons:',
      NumberOfGiftsToDrop: 'Anzahl der fallenden Geschenk-Icons:',
      CampaignLifetimeMaxMovesAvailable: 'Gesamte Kampagnenlimits:',
      AccountLifetimeMaxMovesAvailable: 'Einzelne Benutzer können dieses Spiel nur spielen:',
      AccountIntervalMaxMovesAvailable: 'Einzelne Benutzer können dieses Spiel nur spielen:',
      Times: 'mal',
      Per: 'pro'
    },

    CampaignRequestComment: {
      Content: 'Inhalt',
      DeleteButton: 'Löschen-Button',
      Delete: 'Löschen',
      Time: 'Zeit',

      Title: 'Ausstehende Kampagne',

      Description:
        'Diese Kampagne wartet auf Genehmigung. Hinzugefügte Kommentare werden hier angezeigt.',
      CommentsAdded: 'Kommentare hinzugefügt'
    },

    DeleteCommentModal: {
      SuccessMessage: 'Kommentar gelöscht',
      ErrorMessage: 'Fehler beim Löschen des Kommentars',
      Title: 'Kommentar löschen?',
      OkText: 'Löschen',
      DescriptionLineOne: 'Sind Sie sicher, dass Sie diesen Kommentar löschen möchten?',
      DescriptionLineTwo: 'Diese Aktion kann nicht rückgängig gemacht werden.',
      CancelText: 'Abbrechen'
    },

    ApproveDenyCampaignRequestModalTitle: 'Kampagne genehmigen?',
    ApproveDenyCampaignRequestModalButton: 'Genehmigen',

    ApproveDenyCampaignRequestModal: {
      SuccessMessage: 'Anfrage wurde genehmigt',
      ErrorMessage: 'Etwas ist schiefgelaufen',

      ApproveTitle: 'Kampagne genehmigen?',
      Title: 'Löschantrag einreichen?',
      ApproveOkText: 'Genehmigen',
      OkText: 'Löschung beantragen',
      CancelText: 'Abbrechen',

      ApproveDescriptionLineOne: 'Sind Sie sicher, dass Sie diese Kampagne genehmigen möchten?',
      ApproveDescriptionLineTwo: 'Diese Aktion kann nicht rückgängig gemacht werden.',

      DescriptionLineOne:
        'Diese Kampagne wartet auf Genehmigung. Sind Sie sicher, dass Sie sie löschen möchten?',
      DescriptionLineTwo:
        'Sobald die Löschung genehmigt ist, wird diese Kampagne nicht mehr verfügbar sein und Sie müssen sie neu erstellen.'
    },

    AddCommentModalTitle: 'Kommentare anzeigen und hinzufügen',
    AddCommentModalButton: 'Kommentar hinzufügen',
    AddCommentModal: {
      SuccessMessage: 'Kommentar hinzugefügt',
      ErrorMessage: 'Fehler beim Hinzufügen des Kommentars',
      CancelText: 'Abbrechen',
      CommentInputPlaceholder: 'Geben Sie hier Ihren Kommentar ein',
      AddCommentButton: 'Kommentar hinzufügen'
    },

    CampaignInfoTitle: 'Kampagnen-Info',

    ReviewInfo: {
      Subtitle: 'Untertitel:',
      Description: 'Beschreibung:',
      TnC: 'AGB:',
      RiskDisclaimer: 'Risikohinweis:',
      BranchName: 'Markenname:',
      Tags: 'Tags:',
      Categories: 'Kategorien:',
      Labels: 'Labels:',
      Catalogue: 'Kataloge:',
      UploadImages: 'Hochgeladene Fotos:',
      Merchant: 'Händler:',
      CustomField: 'Benutzerdefinierte Felder:',
      Type: 'Typ:',
      Url: 'Website-URL:',
      Partner: 'Partner:',
      Reset: 'Zurücksetzen:',
      Stackable: 'Stapelbar:',
      Status: 'Status:',
      Name: 'Kampagnenname:',
      Duration: 'Kampagnendauer:',
      StepsToRedeem: 'Einlöseschritte:',
      ActiveAt: 'Aktiv ab:',
      Owner: 'Besitzer:',
      RewardLegacyAudience: 'Wo kann diese Belohnung angezeigt werden:',
      RewardsCost: 'Belohnungskosten:',
      SellingPrice: 'Verkaufspreis:',

      OperatingDays: 'Betriebstage:',
      OperatingPeriod: 'Betriebszeitraum:',

      ReviewMonth: 'Überprüfungsmonat:',
      PromotionSettings: 'Werbeeinstellungen:',
      DemotionSettings: 'Herabstufungseinstellungen:'
    },

    SocialMediaReview: {
      CopyTextSuccessMessage: 'Social Media URL kopiert!',
      Title: 'Social Media',
      OGTitle: 'Titel',
      OGDescription: 'Beschreibung',
      OGImage: 'Bild',
      OGImageAlt: 'Social Media Vorschau',
      AlternativeIOSLinkDescription: 'iOS App-Link',
      AlternativeAndroidURLDescription: 'Android App-Link',
      OGURL: 'Web-Link',
      SocialMediaURL: 'Social Media URL',
      CopyURLButton: 'URL kopieren',
      OGURLDescription: 'Dieser Link wird erst nach dem Start generiert',
      WebLink: 'Web-Link',
      Description: `Das Feld {{webLink}} muss ausgefüllt sein, damit die Social Media URL generiert werden kann`
    },

    AudienceInfoTitle: 'Zielgruppen-Info',

    AudienceInfo: {
      Description: 'Ausgewählte Zielgruppe:',
      NoListsSelected: 'Keine Listen ausgewählt',
      Include: 'Einschließen',
      Exclude: 'Ausschließen',
      AudienceAttributes: 'Zielgruppenattribute',
      AudienceList: 'Zielgruppenliste'
    },

    EnrolmentSettings: 'Anmeldeeinstellungen',
    AutoEnrolUsers: 'Benutzer automatisch anmelden',
    EnrollableUntil: 'Anmeldbar bis',
    AutoRedeemOutcome: 'Ergebnis automatisch einlösen',
    StampMechanics: 'Stempel-Mechanik',
    TotalStampCards: 'Gesamtzahl Stempelkarten',
    TotalStampCardsPerUser: 'Stempelkarten pro Benutzer',
    TotalStamps: 'Gesamtzahl Stempel',
    TotalStampsPerUser: 'Stempel pro Benutzer',

    GameMechanics: {
      Title: 'Spielmechanik',
      HitThePinata: {
        Title: 'Triff die Piñata',
        InstructionsLineOne:
          '1. Endbenutzer erhält eine Belohnung basierend auf einer erforderlichen Aktion, in diesem Fall durch das Treffen der Piñata.',
        InstructionsLineTwo:
          '2. Belohnungen werden basierend auf der eingestellten Wahrscheinlichkeit zufällig vergeben',
        IdealFor: 'Ideal für',
        InstructionsLineThree: '1. Saisonales Spiel',
        HeaderMessage: 'Kopfzeilennachricht',
        GameDesign: 'Spieldesign',
        PlayButtonText: 'Spielen-Button-Text'
      },

      ShakeTheTree: {
        Title: 'Schüttel den Baum',
        InstructionsLineOne:
          'Binden Sie Kunden mit einer Herausforderung ein, die sie zum Schütteln des Telefons auffordert',
        GameMechanics: 'Spielmechanik',
        InstructionsLineTwo:
          '1. Endbenutzer erhält eine Belohnung basierend auf einer erforderlichen Aktion, in diesem Fall durch das Schütteln des Telefons',
        InstructionsLineThree:
          '2. Belohnungen werden basierend auf der eingestellten Wahrscheinlichkeit zufällig vergeben',
        IdealFor: 'Ideal für',
        InstructionsLineFour: '1. Saisonales Spiel',
        HeaderMessage: 'Kopfzeilennachricht',
        GameDesign: 'Spieldesign',
        TreeVisual: 'Baum-Visual',
        GiftVisual: 'Geschenk-Visual',
        PlayButtonText: 'Spielen-Button-Text'
      },

      QuizOrSurveyTypeGame: {
        Properties: 'Eigenschaften',

        GameMeta: {
          ScratchCard: 'Rubbellos',
          ScratchCardDetails:
            'Binden Sie Kunden mit einer Herausforderung ein, die sie zum Rubbeln einer Spielkarte auffordert.',
          HitThePinata: 'Triff die Piñata',
          HitThePinataDetails:
            'Binden Sie Kunden mit einer Herausforderung ein, die sie zum Schütteln des Telefons auffordert.',
          ShakeTheTree: 'Schüttel den Baum',
          ShakeTheTreeDetails:
            'Binden Sie Kunden mit einer Herausforderung ein, die sie zum Tippen auf das Objekt auffordert.',
          SpinTheWheel: 'Dreh das Glücksrad',
          SpinTheWheelDetails: 'Binden Sie den Kunden mit einem Glücksrad ein.',
          Plinko: 'Plinko',
          PlinkoDetails: 'Lass den Ball fallen und erhalte glückliche Abpraller'
        },

        GameGraphics: {
          AppGraphics: 'App-Grafiken',
          PreScratch: 'Vor dem Rubbeln',
          PostSuccess: 'Nach (Erfolg)',
          PostFail: 'Nach (Misserfolg)',
          RewardIcon: 'Belohnungssymbol',
          NumberOfWedges: 'Anzahl der Segmente',
          WedgeColors: 'Segmentfarben',
          Wedge: 'Segment',
          WheelImage: 'Radbild',
          WheelPosition: 'Radposition',
          PointerImage: 'Zeigerbild',
          Headline: 'Überschrift',
          Subheadline: 'Unterüberschrift',
          AppBackground: 'App-Hintergrund',
          ButtonText: 'Button-Text',

          FrameColor: 'Rahmenfarbe',
          BallColor: 'Ballfarbe',
          HeadlineTextColor: 'Überschrift-Textfarbe',
          SubheadlineTextColour: 'Unterüberschrift-Textfarbe'
        },

        Survey: 'Umfrage',
        SurveyDetails: 'Binden Sie den Kunden mit Multiple-Choice-Fragen ein.',
        Quiz: 'Quiz',
        QuizDetails: 'Binden Sie den Kunden mit Multiple-Choice-Fragen ein.',
        BackgroundImage: 'Hintergrundbild',
        Submit: 'Absenden'
      }
    },

    RewardLimits: {
      Title: 'Belohnungslimits',
      DescriptionLineOne: 'Gesamtzahl der ausgebbaren Belohnungen:',
      DescriptionLineTwo: 'Anzahl der Belohnungen, die jeder Benutzer erhalten kann:',
      DescriptionLineThree: 'Einzelne Benutzer können dieses Spiel nur spielen:',
      DescriptionLineFour: 'Kampagne gibt nur Belohnungen aus:',
      InTotal: 'insgesamt',
      Times: 'mal',
      Per: 'pro'
    },

    Rules: 'Regeln',

    RulePreview: {
      MoreOutcomes: '+{{count}} weitere(s) Ergebnis(se)',
      ID: 'ID',
      RulesBalance: 'Regelstand',
      Of: 'von',
      Trigger: 'Auslöser',
      Type: 'Typ',
      Conditions: 'Bedingungen',
      EventName: 'Ereignisname',
      CampaignId: 'Kampagnen-ID',
      RewardId: 'Belohnungs-ID',
      LoyaltyId: 'Treue-ID',
      LoyaltyTierId: 'Treueprogramm-Stufen-ID',
      AutomationTriggerId: 'Automatisierungs-Trigger-ID',
      Outcome: 'Ergebnis',
      NumberOfStamps: 'Anzahl der Stempel',
      AwardPoints: 'Punkte vergeben',
      ForEveryCurrency: 'Für jede Währung',
      UpToAMaximumOfPoints: 'Bis zu einer maximalen Punktzahl von',
      UserEarnsOneRaffleTicket: 'Benutzer erhält 1 Gewinnspiellos',
      TheTaskWillBeMarkedAsDone: 'Die Aufgabe wird als "erledigt" markiert',
      Points: 'Punkte',
      LoyaltyProgram: 'Treueprogramm',
      Award: 'Vergeben',
      GlAccountNumber: 'GL-Kontonummer',
      GlAccountName: 'GL-Kontoname',
      CostCenterId: 'Kostenstellen-ID',
      BranchCode: 'Filialcode',
      Reward: 'Belohnung',
      Name: 'Name',
      SellingFrom: 'Verkauf ab',
      Limits: 'Limits',
      MaximumEvents: 'Maximale Ereignisse',
      PerCampaign: 'pro Kampagne',
      PerUser: 'pro Benutzer',
      TriggerRateLimit: 'Auslöser-Ratenlimit',
      PerUserForEvery: 'pro Benutzer für jeden',
      StreakCampaignMechanics: 'Serienkampagnen-Mechanik',
      StreakTarget: 'Serienziel',
      StreakPeriod: 'Serienzeitraum',
      UserMustPerform: 'Benutzer muss ausführen',
      UserMust: 'Benutzer muss',
      TargetCriteria: 'Zielkriterien',
      AtLeast: 'mindestens',
      Within: 'innerhalb',
      CurrencyWithin1: 'Währung innerhalb von 1',
      TimesWithin1: 'Mal innerhalb von 1',
      TransactionsWithin: 'Transaktionen innerhalb'
    },
    ActionMechanics: 'Aktionsmechanik',

    InstantRewardMechanics: 'Sofortbelohnungsmechanik',
    InstantRewardMechanicsLabel: 'Kampagne in der Kampagnenliste des Benutzers anzeigen?',
    IssuanceLimits: 'Ausgabelimits',
    IssuanceLimitsLabel: 'Gesamtzahl der Preisausgabe-Ereignisse (auf Kampagnenebene)',
    AccountLifetimeMaxAvailableLabel: 'Gesamtzahl der Preisausgabe-Ereignisse (pro Benutzer)',
    RateLimitCampaignLabel: 'Ratenlimit (auf Kampagnenebene)',
    RateLimitUserLabel: 'Ratenlimit (pro Benutzer)',
    Outcomes: 'Ergebnisse',
    IssuePrizeEvents: 'Preisausgabe-Ereignis(se)',
    LimitTo: 'Limitieren auf',
    ForEvery: 'für jeden',

    PrizeSet: {
      Outcomes: 'Ergebnisse',
      QuizSelectableOne: 'Preise für das Abschließen des Quiz vergeben',
      QuizSelectableTwo: 'Punkte pro richtige Antwort vergeben',
      PointsPerAnswerLabel: 'Punkte pro richtige Antwort:',
      Points: 'Punkte',
      Edit: 'Bearbeiten',
      Remove: 'Entfernen',
      NoPrizeAdded: 'Kein Preis hinzugefügt',
      Prizes: 'Preise',
      AddRandomPrize: 'Zufälligen Preis hinzufügen',
      AddPrizeSet: 'Preisset hinzufügen',
      AddRewards: 'Belohnungen hinzufügen',
      AwardPoints: 'Punkte vergeben',
      AwardBadges: 'Abzeichen vergeben',
      AddPrize: 'Preis hinzufügen',
      IncludeNoPrizeAsOutcome: 'Kein Preis als mögliches Ergebnis einschließen',

      GLACDetail: 'GL-Kontodetail',
      GLACNo: 'GL-Kontonr.',
      GLACName: 'GL-Kontoname',
      CostCenterID: 'Kostenstellen-ID',
      BranchCode: 'Filialcode',

      WinOdds: 'Gewinnchance',
      Prize: 'Preis',
      Merchant: 'Händler',
      Balance: 'Guthaben'
    },

    PrizePerAnswer: {
      CountOfPointsValidationMessage: 'Bitte geben Sie die Anzahl der Punkte pro Antwort an',
      LoyaltyProgramValidationMessage: 'Bitte wählen Sie ein Treueprogramm',
      Title: 'Punkte pro richtige Antwort',
      OkText: 'Speichern',
      CancelText: 'Abbrechen',
      LoyaltyProgramLabel: 'Treueprogramm auswählen',
      LoyaltyProgramSelectPlaceholder: 'Treueprogramm auswählen',
      CountOfPointsLabel: 'Vergeben'
    },

    RewardSelectModal: {
      Title: 'Belohnung auswählen',
      OkText: 'Belohnung hinzufügen',
      CancelText: 'Abbrechen',
      SearchPlaceholder: 'Belohnung nach Name, ID oder Händler suchen',
      ID: 'ID',

      Tabs: {
        All: 'Alle',
        Active: 'Aktiv',
        Approved: 'Genehmigt',
        Private: 'Privat',
        System: 'System'
      },

      Reward: 'Belohnung',
      Merchant: 'Händler',
      Balance: 'Guthaben',
      SellingFrom: 'Verkauf ab',
      SellingTo: 'Verkauf bis'
    },

    IssuePointsModal: {
      ShowVariablePointsValidationMessage: 'Bitte geben Sie die Anzahl der Punkte an',
      LoyaltyProgramValidationMessage: 'Bitte geben Sie ein Treueprogramm an',
      ShowVariablePointsOutcomeValidatioMessage: 'Dieses Feld ist erforderlich',
      GLAccountTypeValidationMessage: 'Bitte wählen Sie einen GL-Kontotyp',
      GLAccountNameValidationMessage: 'Bitte wählen Sie einen GL-Kontonamen',
      GLAccountIDValidationMessage: 'Bitte wählen Sie ein GL-Konto',

      FixedPoints: 'Feste Punkte',
      VariablePoints: 'Variable Punkte',

      IssuePoints: 'Punkte vergeben',
      Save: 'Speichern',
      Cancel: 'Abbrechen',
      SelectLoyaltyProgramLabel: 'Treueprogramm auswählen',
      ShowVariablePointsAlertMessage:
        'Sie können entweder feste oder variable Punkte vergeben. Bei variablen Punkten wird die letzte Transaktion des Benutzers berücksichtigt.',
      NumberOfPointsToAward: 'Zu vergebende Punktzahl',
      NumberOfPointsToAwardPlaceholder: 'z.B. 10',
      SelectGLAccount: 'GL-Konto auswählen',
      SelectGLAccountPlaceholder: 'GL-Konto auswählen',
      GLAccountType: 'GL-Kontotyp',
      GLAccountTypePlaceholder: 'GL-Kontotyp',
      GLAccountName: 'GL-Kontoname',
      GLAccountNamePlaceholder: 'GL-Kontoname'
    },

    VariablePointsPane: {
      Transaction: 'Transaktion',
      Award: 'Vergeben',
      Every: 'Jede',
      UpToAMaximumAmountOf: 'Bis zu einem Maximalbetrag von'
    },

    BadgeSelectModal: {
      Title: 'Abzeichen zur Anzeige auswählen',
      OkText: 'Abzeichen hinzufügen',
      CancelText: 'Abbrechen'
    },

    BadgeListTable: {
      Name: 'Name',
      StartDate: 'Startdatum',
      EndDate: 'Enddatum',
      Actions: 'Aktionen',
      ID: 'ID',
      SearchBadgesPlaceholder: 'Abzeichen suchen',
      Edit: 'Bearbeiten',
      Deactivate: 'Deaktivieren',
      Activate: 'Aktivieren',
      ErrorSortingBadgeMessage: 'Fehler beim Sortieren des Abzeichens.',
      ErrorUpdatingBadgeStateMessage: 'Fehler beim Aktualisieren des Abzeichenstatus',
      Status: 'Status'
    },

    ReviewOutcomesDisplay: {
      IncludeNoOutcome: 'Kein Ergebnis einschließen',
      All: 'Alle',
      Active: 'Aktiv',
      Approved: 'Genehmigt',
      Inactive: 'Inaktiv',
      Ended: 'Beendet',
      Private: 'Privat',
      Points: 'Punkte',
      Custom: 'Benutzerdefiniert'
    },

    StampCampaignOutcomes: {
      GLAccountNo: 'GL-Kontonr.',
      GLAccountName: 'GL-Kontoname',
      CostCenterID: 'Kostenstellen-ID',
      BranchCode: 'Filialcode',
      GLAccountDetail: 'GL-Kontodetail',

      Slot: 'Slot',
      OutcomeType: 'Ergebnistyp',
      AddRewards: 'Belohnungen hinzufügen',
      AwardPoints: 'Punkte vergeben',
      AwardBadges: 'Abzeichen vergeben',
      AddPrizeToSet: 'Preis zum Set hinzufügen',
      IncludeNoPrizeAsOutcome: 'Kein Preis als mögliches Ergebnis einschließen',
      AddAnotherReward: 'Weitere Belohnung hinzufügen',
      AddAnotherBadge: 'Weiteres Abzeichen hinzufügen',
      RewardName: 'Belohnungsname',
      NumberOfPoints: 'Punktzahl',
      ID: 'ID',
      Reward: 'Belohnung',
      Action: 'Aktion',
      Delete: 'Löschen',
      NoOutcome: 'Kein Ergebnis',
      ChangeByAddingReward: 'durch Hinzufügen einer Belohnung ändern',
      AddFixedPrizeSet: 'Festes Preisset hinzufügen',
      AddRandomPrize: 'Zufälligen Preis hinzufügen',
      IssueReward: 'Belohnung vergeben',
      IssuePoints: 'Punkte vergeben',
      IssueBadges: 'Abzeichen vergeben',
      AwardGameTry: 'Spielversuche vergeben',
      SlotsWithOutcomeAdded: 'Slots mit hinzugefügtem Ergebnis'
    },

    OutcomeSettings: {
      Title: 'Ergebniseinstellungen',
      PrizeSet: 'Preisset',
      Submit: 'Absenden',
      MixedRewardsButtonText: 'Button-Text basierend auf der ersten aufgelisteten Belohnung',
      Headline: 'Überschrift'
    },

    GameOutcomeScreens: {
      QuizScreens: 'Quiz-Bildschirme',
      SurveyScreens: 'Umfrage-Bildschirme',
      LandingPage: 'Landingpage',
      LandingScreenHeading: 'Landingpage-Überschrift',
      LandingScreenSubheading: 'Landingpage-Unterüberschrift',
      LandingScreenButtonText: 'Landingpage-Button-Text',
      LandingScreenText: 'Landingpage-Text',
      OutcomeScreen: 'Ergebnis-Bildschirm',
      SuccessfulOutcomeMessage: 'Erfolgreiches Ergebnis Nachricht',
      SuccessfulOutcomeButton: 'Erfolgreiches Ergebnis Button',
      NoOutcomeMessage: 'Kein Ergebnis Nachricht',
      NoOutcomeButton: 'Kein Ergebnis Button',
      OutcomeScreens: 'Ergebnis-Bildschirme',
      WinRewardGraphic: 'Gewinn-Belohnung Grafik',
      WinRewardMessage: 'Gewinn-Belohnung Nachricht',
      WinRewardButton: 'Gewinn-Belohnung Button'
    },

    TeamMechanics: 'Team-Mechanik',
    MemberPerTeam: 'Mitglieder pro Team',
    DisplaySetup: 'Anzeigeeinrichtung',
    LandingPage: 'Landingpage',
    PreEnrolmentMessage: 'Voranmeldungsnachricht',
    StampsEarnMessage: 'Stempel-Sammeln Nachricht',
    JoinTeamPagePreview: {
      Title: 'Einem Team beitreten',
      ButtonText: 'Team beitreten',
      InputPlaceholder: 'Team-Code'
    },
    JoinTeamPage: 'Team-Beitrittsseite',
    JoinTeamInfoMessage: 'Team-Beitritt Infonachricht',
    InviteMemberMessage: 'Mitglied-Einladungsnachricht',
    InviteMemberMessageDescription: 'Mitglied-Einladungsnachricht Beschreibung',
    InviteMemberMessageBlurb: 'Mitglied-Einladungsnachricht Kurztext',

    QuestMechanics: 'Quest-Mechanik',
    UserTriesValidity: 'Gültigkeit der Benutzerversuche',
    Task: 'Aufgabe',
    QuestTask: {
      AddRule: 'Regel hinzufügen',
      Required: '*erforderlich'
    },
    TotalQuests: 'Gesamtzahl der Quests, die in einer Kampagne gestartet werden können',
    TotalQuestsPerUser: 'Gesamtzahl der Quests, die von jedem Benutzer gestartet werden können',
    DisplaySetItup: 'Anzeige einrichten',

    CampaignRuleFormModal: {
      ValidationMessages: {
        PleaseSelectATriggerEvent: 'Bitte wählen Sie ein Auslöser-Ereignis aus',
        PleaseSelectALoyaltyProgramValue: 'Bitte wählen Sie einen Treueprogrammwert aus',
        PleaseSelectALoyaltyTierValue: 'Bitte wählen Sie eine Treuestufe aus',
        PleaseSelectACampaign: 'Bitte wählen Sie eine Kampagne aus',
        PleaseSelectAStampCampaign: 'Bitte wählen Sie eine Stempel-Kampagne aus',
        PleaseEnterTheNumberOfStamps: 'Bitte geben Sie die Anzahl der Stempel ein',
        NumberOfStampsMustBeAtLeastOne: 'Die Anzahl der Stempel muss mindestens 1 betragen',
        StampPositionMustBeAtLeastOne: 'Die Stempelposition muss mindestens 1 betragen',
        PleaseEnterTheStampPosition: 'Bitte geben Sie die Stempelposition ein',
        PleaseSelectAnAutomationTrigger: 'Bitte wählen Sie einen Automatisierungsauslöser aus',
        IntervalCannotBeLessThanZero: 'Das Intervall darf nicht kleiner als Null sein',
        IntervalCannotBeGreaterThan365: 'Das Intervall darf nicht größer als 365 sein',
        PleaseEnterTheInterval: 'Bitte geben Sie das Intervall ein',
        PleaseSelectAMilestone: 'Bitte wählen Sie einen Meilenstein aus',
        PleaseSelectARule: 'Bitte wählen Sie eine Regel aus',
        PleaseSelectAReward: 'Bitte wählen Sie eine Belohnung aus',
        ThisFieldIsRequired: 'Dieses Feld ist erforderlich',
        TheFieldIsRequired: 'Das Feld ist erforderlich',

        AttributeIsRequired: 'Attribut ist erforderlich',
        OperatorIsRequired: 'Operator ist erforderlich',
        PleaseSelectAtLeastOneDay: 'Bitte wählen Sie mindestens einen Tag aus',
        PleaseSelectATime: 'Bitte wählen Sie eine Uhrzeit aus',
        FromTimeMustBeLessThanToTime: 'Die Startzeit muss vor der Endzeit liegen',
        PleaseSelectAFormTime: 'Bitte wählen Sie eine Startzeit aus',
        PleaseSelectAnToTime: 'Bitte wählen Sie eine Endzeit aus',
        PleaseConfigureTheRuleTriggerDays: 'Bitte konfigurieren Sie die Regel-Auslösetage',

        PleaseConfigureTheTrigger: 'Bitte konfigurieren Sie den Auslöser',
        PleaseFillInTheNameOfTheRule: 'Bitte geben Sie den Namen der Regel ein',
        PleaseSelectAnOwner: 'Bitte wählen Sie einen Besitzer aus',
        PleaseSelectATriggerRule: 'Bitte wählen Sie eine Auslöseregel aus',
        PleaseSpecifyAStartTime: 'Bitte geben Sie eine Startzeit an',
        PleaseSpecifyAValidEndTime: 'Bitte geben Sie eine gültige Endzeit an',
        PleaseSelectAnOutcomeType: 'Bitte wählen Sie einen Ergebnistyp aus',
        PleaseSelectAMediaTag: 'Bitte wählen Sie ein Medien-Tag aus',
        PleaseSelectAGLAccountType: 'Bitte wählen Sie einen GL-Kontotyp aus',
        PleaseSelectAGLAccountName: 'Bitte wählen Sie einen GL-Kontonamen aus',
        GLAccountIDIsRequired: 'GL-Konto-ID ist erforderlich',
        PleaseEnterAKey: 'Bitte geben Sie einen Schlüssel ein',
        AtLeastOneOutcomePropertyIsRequired:
          'Mindestens eine Ergebnis-Eigenschaft ist erforderlich',
        OutcomePropertiesAreRequired: 'Ergebnis-Eigenschaften sind erforderlich',
        ValueMustBeGreaterThanZero: 'Der Wert muss größer als Null sein.',
        ValueCannotBeZero: 'Der Wert darf nicht Null sein.',
        PleaseEnterANumber: 'Bitte geben Sie eine Zahl ein',
        PleaseEnterAWholeNumber: 'Bitte geben Sie eine ganze Zahl ein',
        NumberMustBeAPositiveNumber: 'Die Zahl muss positiv sein',

        OutcomeRequiredErrorMessage: 'Dieses Feld ist erforderlich',
        OutcomePointsRequiredErrorMessage: 'Bitte wählen Sie ein Treueprogramm aus'
      },
      Title: 'Kampagnenregel',
      RuleName: 'Regelname',
      Priority: 'Priorität',
      Outcome: 'Ergebnis',
      Edit: 'Bearbeiten',
      Create: 'Erstellen',
      Update: 'Aktualisieren',
      Add: 'Hinzufügen',
      CancelText: 'Abbrechen',
      RequiredErrorMessage: 'Dieses Feld ist erforderlich.',
      OutcomeRewardRequiredErrorMessage: 'Bitte wählen Sie eine Belohnung',
      OutcomePointsRequiredErrorMessage: 'Bitte wählen Sie ein Treueprogramm',
      GLAccountTypeRequiredErrorMessage: 'Bitte wählen Sie einen GL-Kontotyp',
      GLAccountNameRequiredErrorMessage: 'Bitte wählen Sie einen GL-Kontonamen',
      OutcomeRequiredErrorMessage: 'Dieses Feld ist erforderlich',
      StampsWillBeIssued: 'Stempel werden ausgegeben',
      FixedPoints: 'Feste Punkte',
      VariablePoints: 'Variable Punkte',
      EarnType: 'Ertragstyp',
      Award: 'AWARD',
      Points: 'Punkte',
      ForEvery: 'Für jeden',
      Currency: 'Währung',
      UpToAMaximumOf: 'Bis zu einem Maximalbetrag von',
      QuestOutcomeSegment: 'Die Aufgabe wird als ‘done’ markiert',
      InviteOutcomeSegment: 'Die Aufgabe wird als ‘done’ markiert',
      RaffleOutcomeSegment: 'Der Benutzer erhält einen Gewinnspielschein',
      SelectOutcomeType: 'Ergebnistyp auswählen',
      Reward: 'Belohnung',
      ChangeReward: 'Belohnung ändern',
      SelectReward: 'Belohnung auswählen',
      SelectLoyaltyProgram: 'Treueprogramm auswählen',
      NumberOfPoints: 'Anzahl der Punkte',
      SelectGLAccount: 'GL-Konto auswählen',
      GLAccountType: 'GL-Kontotyp',
      GLAccountTypePlaceholder: 'GL-Kontotyp',
      GLAccountName: 'GL-Kontoname',
      GLAccountNamePlaceholder: 'GL-Kontoname'
    },

    SelectTriggerSection: {
      SelectATrigger: 'Auslöser auswählen',
      Custom: 'Benutzerdefiniert',
      Transaction: 'Transaktion',
      Loyalty: 'Treue',
      Campaign: 'Kampagne',
      Customer: 'Kunde',
      Reward: 'Belohnung',
      Location: 'Standort',
      SelectTrigger: 'Auslöser auswählen',
      SelectATriggerPlaceholder: 'Bitte wählen Sie einen Auslöser',
      Others: 'Benutzerdefiniert',
      LoyaltyTrigger: {
        HelpText: 'Die Anzahl der ablaufenden Punkte wird zu Beginn jedes Prüfzyklus überprüft.',
        AchievedNextTier: 'Nächste Stufe erreicht',
        TenPercentCloseToNextTier: '10% bis zur nächsten Stufe',
        PointsIssued: 'Punkte vergeben',
        AgeingPoints: 'Alternde Punkte (Punkte, die im aktuellen Zyklus ablaufen)',
        SelectLoyaltyProgram: 'Treueprogramm auswählen',
        SelectNextTier: 'Nächste Stufe auswählen',
        SelectNextTierPlaceholder: 'Bitte wählen Sie eine Stufe'
      },
      RewardTrigger: {
        RedeemReward: 'Belohnung einlösen',
        IssueReward: 'Belohnung ausgeben',
        IssueRewardFromCampaign: 'Belohnung aus Kampagne ausgeben',
        IssueRewardFromMerchant: 'Belohnung vom Händler ausgeben',
        VoucherForParticularRewardExpiringIn: 'Gutschein für bestimmte Belohnung läuft ab in',
        AnyVoucherExpiringIn: 'Beliebiger Gutschein läuft ab in {{days}}'
      },

      MilestoneTrigger: {
        StampRedeemed: 'Stempel eingelöst',
        StampsIssued: 'Stempel ausgegeben',
        StampsInactive: 'Stempel inaktiv',
        GamePlayed: 'Spiel gespielt',
        GameTryIssued: 'Spielversuch ausgegeben',
        CampaignEnrolled: 'An Kampagne teilgenommen',
        CampaignCompleted: 'Kampagne abgeschlossen',
        CampaignNotCompleted: 'Kampagne nicht abgeschlossen',
        ProgressLevelAchieved: 'Fortschrittsstufe erreicht',
        ProgressRuleTriggered: 'Fortschrittsregel ausgelöst',
        QuestTaskCompleted: 'Quest-Aufgabe abgeschlossen',

        SelectAStampCampaign: 'Stempel-Kampagne auswählen',
        Change: 'Ändern',
        Select: 'Auswählen',
        Stamp: 'Stempel',
        Campaign: 'Kampagne',
        ID: 'ID',
        FooterMsg:
          'Jede {{isCampaignRewardsSelected}} Belohnung in dieser Kampagne wird ein Auslöser',
        SelectStampsSlot: 'Stempel-Slot auswählen',
        StampCardPosition: 'Stempel-Kartenposition'
      },

      CustomerTrigger: {
        SignUp: 'Registrieren',
        SignIn: 'Anmelden',
        ProfileUpdated: 'Profil aktualisiert'
      },

      TransactionTrigger: {
        SelectATriggerPlaceholder: 'Wählen Sie einen Auslöser...',
        FromDate: 'Von Datum',
        ToDate: 'Bis Datum',
        SelectOperator: 'Operator auswählen',
        PropertyDataType: 'Eigenschaftsdatentyp',
        Key: 'Schlüssel',
        Operator: 'Operator',
        Sunday: 'Sonntag',
        Monday: 'Montag',
        Tuesday: 'Dienstag',
        Wednesday: 'Mittwoch',
        Thursday: 'Donnerstag',
        Friday: 'Freitag',
        Saturday: 'Samstag',
        Value: 'Wert',
        PleaseSeparateMultipleValuesUsingComma: 'Bitte trennen Sie mehrere Werte mit einem Komma',
        SelectTrigger: 'Auslöser auswählen',
        And: 'Und',
        AddCondition: 'Bedingung hinzufügen'
      },

      LocationTrigger: {
        EnterLocationDetails: 'Standortdetails eingeben',
        Latitude: 'Breitengrad',
        Longitude: 'Längengrad',
        LatitudeDegrees: 'Grad ( -90.0 to 90.0 )',
        LongitudeDegrees: 'Grad ( -180.0 to 180.0 )',
        PermissibleRadius: 'Zulässiger Radius (In Meter)',
        Radius: 'Zulässiger Radius',
        Preview: 'VORSCHAU'
      },
      CampaignSelectField: {
        Interval: 'Intervall',
        Days: '(Tage)',
        SelectAStampCampaign: 'Stempel-Kampagne auswählen',
        Change: 'Ändern',
        Select: 'Auswählen',
        Stamp: 'Stempel',
        SelectACampaign: 'Kampagne auswählen',
        Edit: 'Bearbeiten',
        Add: 'Hinzufügen',
        Campaign: 'Kampagne',
        SelectAMilestone: 'Meilenstein auswählen',
        SelectARule: 'Regel auswählen',
        SelectATask: 'Aufgabe auswählen'
      },

      GameSelectField: {
        SelectAGameCampaign: 'Spiel-Kampagne auswählen',
        Game: 'Spiel',
        Campaign: 'Kampagne',
        Change: 'Ändern',
        Select: 'Auswählen'
      },

      CampaignRewardSelectField: {
        SelectACampaign: 'Kampagne auswählen',
        Change: 'Ändern',
        Select: 'Auswählen',
        Campaign: 'Kampagne',
        SelectAReward: 'Belohnung auswählen (Optional)',
        Reward: 'Belohnung'
      },

      MerchantRewardSelectField: {
        SelectAMerchant: 'Händler auswählen',
        Change: 'Ändern',
        Select: 'Auswählen',
        Merchant: 'Händler',
        AddMerchant: 'Händler hinzufügen',
        Cancel: 'Abbrechen',
        SearchMerchant: 'Händler nach Name oder ID suchen',
        Active: 'Aktiv',
        Inactive: 'Inaktiv'
      },

      RewardSelectField: {
        SelectAReward: 'Belohnung auswählen (Optional)',
        Change: 'Ändern',
        Reward: 'Belohnung',
        Select: 'Auswählen',
        WarningText:
          'Ergebnistyp ist auf [Push Event] beschränkt, wenn eine System-Belohnung ausgewählt ist'
      },

      RewardExpirySetupField: {
        SelectAReward: 'Belohnung auswählen',
        Change: 'Ändern',
        Select: 'Auswählen',
        Reward: 'Belohnung',
        Periods: 'Zeiträume (Tage)'
      }
    },

    RuleTriggerLimitSegment: {
      Title: 'Auslöserlimits:',
      TotalTriggerEvents: 'Gesamtzahl der Auslöserereignisse (auf Kampagnenebene)',
      TotalTriggerEventsPerUser: 'Gesamtzahl der Auslöserereignisse (pro Benutzer)',
      TriggerRateLimitPerUser: 'Auslöser-Ratenlimit (pro Benutzer)',
      LeaveTheLimitFieldsBlankForUnlimitedTriggerEvents:
        '- Lassen Sie die Limit-Felder leer für unbegrenzte Auslöserereignisse -',
      Days: 'Tage',
      Weeks: 'Wochen',
      Months: 'Monate',
      Years: 'Jahre',
      TriggerEventForEvery: 'Auslöserereignis(se)^ für jeden',
      AccountIntervalLimitPlaceholder: 'z.B. 2',
      AccountIntervalUnitsPlaceholder: 'z.B. 1',
      TriggerLimitPlaceholder: '∞',
      TriggerAccountLimitPlaceholder: '∞',
      LimitTo: 'Limitieren auf'
    },

    RuleAudience: {
      SelectFilters: 'Filter auswählen',
      Age: 'Alter',
      Gender: 'Geschlecht',
      Location: 'Standort',
      Language: 'Sprache',
      Device: 'Gerät',
      Browser: 'Browser',
      Customs: 'Benutzerdefiniert',
      Ethnicity: 'Ethnizität',
      Loyalty: 'Treue',
      EmailTags: 'E-Mail-Tags',
      BirthMonth: 'Geburtsmonat',
      NoFiltersSelected: 'Keine Filter ausgewählt',
      SelectedFilters: 'Ausgewählte Filter'
    },

    LoyaltyTier: {
      Includes: 'beinhaltet',
      UsersWhoAchieved: 'Benutzer, die erreicht haben',
      SelectProgramAndTier: 'Programm und Stufe auswählen'
    },

    LevelsAndPrizes: 'Level & Preise',

    LevelWrapper: {
      ValidatePointHelpMessage:
        'Level {{level}} Punkte müssen mehr als Level {{previousLevel}} Punkte sein!',
      LevelTitle: 'Level {{level}} Anzeige',
      TotalCampaignPointsRequired: 'Erforderliche Gesamtkampagnenpunkte für dieses Level:'
    },

    ClaimPrizePopUp: '`Preis beanspruchen` Pop-up',

    LandingPagePreview: {
      CampaignName: 'Kampagnenname',
      Description: 'Beschreibung',
      TermsAndConditions: 'Allgemeine Geschäftsbedingungen',
      PRIZE: 'PREIS',
      PrizeSet: 'Preisset',
      StartPlaying: 'Spielen beginnen'
    },

    EnrolmentPage: 'Anmeldeseite',

    RuleGroupLandingPagePreview: {
      CampaignName: 'Kampagnenname',
      EnrollText: 'ANMELDEN',
      EnrollNow: 'Jetzt anmelden',
      TermsAndConditions: 'Allgemeine Geschäftsbedingungen'
    },

    RaffleReview: {
      DisplaySettings: 'Anzeigeeinstellungen',
      LandingPage: 'Landingpage',
      RaffleTicket: 'Gewinnspiellos',
      GrandPrize: 'Hauptpreis',
      GrandPrizes: 'Hauptpreise'
    },

    DrawSection: {
      RaffleDraw: 'Gewinnspielziehung',
      DownloadCSV: 'CSV herunterladen',
      GenerateRaffleWinners: 'Gewinnspielgewinner generieren',
      SomethingWentWrong: 'Etwas ist schiefgelaufen',
      RaffleCampaignPending:
        'Die Gewinnspielkampagne ist beendet. Klicken Sie auf "Gewinnspielgewinner generieren", um die Gewinnspielziehung auszulösen und automatisch Preise an die Gewinner zu vergeben. Sie können die Liste der Gewinner sehen, sobald die Ziehung abgeschlossen ist.',
      RaffleCampaignSuccess:
        'Die Gewinnspielziehung ist abgeschlossen und die Gewinner haben die Hauptpreise erhalten.'
    },

    GenerateWinnerModal: {
      GeneratingRaffleWinners: 'Gewinnspielgewinner werden generiert...'
    },

    RaffleWinnersTable: {
      Position: 'Position',
      FirstName: 'Vorname',
      LastName: 'Nachname',
      CustomerID: 'Kunden-ID',
      TicketCode: 'Loscode',
      GrandPrize: 'Hauptpreis',
      PrizeSet: 'Preisset',
      ErrorFetchingWinnersList: 'Fehler beim Abrufen der Gewinnerliste'
    },

    ConfigureRaffleCodesReview: {
      ConfigureRaffleCodes: 'Gewinnspielcodes konfigurieren',
      CodeGenerationMethod: 'Code-Generierungsmethode',
      TicketCodePrefix: 'Loscode-Präfix',
      LengthOfCode: 'Code-Länge',
      TotalPermutations: 'Gesamtanzahl Permutationen',
      VoucherCodeFormat: 'Gutscheincode-Format',
      VoucherCodeLength: 'Gutscheincode-Länge',
      NumberOfTickets: 'Anzahl der Lose',
      CodeFormat: 'Code-Format'
    },

    RewardAddedTable: {
      Order: 'Reihenfolge',
      Probability: 'Wahrscheinlichkeit',
      Name: 'Name',
      Value: 'Wert',
      Operators: 'Operatoren',
      RuleName: 'Regelname',
      NoOutcome: 'Kein Ergebnis',
      AwardPoints: 'Punkte vergeben',
      Merchant: 'Händler',
      ID: 'ID',
      SellingFrom: 'Verkauf ab',
      SellingTo: 'Verkauf bis',
      RewardBalance: 'Belohnungsstand',
      PointsAwarded: 'Vergebene Punkte',
      ReferrerLimits: 'Empfehlerlimits',
      RefferalsNeeded: 'Benötigte Empfehlungen',
      ReffererRewardLimit: 'Empfehlungsbelohnungslimit',
      RefereeLimits: 'Empfängerlimits',
      GLACNo: 'GL-Kontonummer',
      GLACName: 'GL-Kontoname',
      CostCenterID: 'Kostenstellen-ID',
      BranchCode: 'Filialcode',
      GLAccountDetail: 'GL-Kontodetails'
    },

    QuizQuestionsReview: {
      Questions: 'Fragen',
      Type: 'Typ',
      TextQuestion: 'Textfrage',
      ImageQuestion: 'Bildfrage',
      WrittenResponse: 'Schreibfrage',
      MultipleAnswers: 'Mehrfachauswahl',
      SingleAnswer: 'Einfachauswahl',
      Question: 'Frage',
      Required: 'Erforderlich',
      Yes: 'Ja',
      No: 'Nein'
    },

    QuestRuleTable: {
      ID: 'ID',
      Name: 'Name',
      Status: 'Status',
      Action: 'Aktion',
      Edit: 'Bearbeiten',
      Remove: 'Löschen'
    },

    BulkActionModal: {
      FileUploadedIsSubmittedForApproval: 'Datei hochgeladen und zur Genehmigung vorgelegt',
      FileUploaded: 'Datei hochgeladen',
      ErrorUploadingFile: 'Fehler beim Hochladen der Datei.',
      Cancel: 'Abbrechen',
      Upload: 'Hochladen',
      BulkUpload: 'Bulk Upload',
      ChooseOne: 'Wählen Sie einen...',
      Campaign: 'Kampagne',
      PleaseSelectACampaign: 'Bitte wählen Sie eine Kampagne',
      LoyaltyProgram: 'Treueprogramm',
      PleaseSelectALoyaltyProgram: 'Bitte wählen Sie ein Treueprogramm',
      ClickOrDragFileToThisAreaToUpload: 'Klicken oder Drag & Drop der Datei in diese Fläche',
      DownloadSample: 'Beispiel herunterladen',
      ActionType: 'Aktionstyp',
      AcceptedFormatXlsxOrCsvFilesOnly: 'Akzeptierte Dateiformat: .xlsx oder .csv Dateien nur',
      AcceptedFormatTxtXlsxOrCsvFilesOnly:
        'Akzeptierte Dateiformat: .txt, .xlsx oder .csv Dateien nur'
    }
  },

  [ReferralRewardModeKey]: {
    Label: 'Empfehlungsprämientyp',
    Fixed: 'Feste Empfehlungsprämie',
    TierBased: 'Stufenbasierte Empfehlungsprämie'
  },

  [ReferralTierLadderKey]: {
    AddTier: 'Stufe hinzufügen',
    RemoveTier: 'Stufe entfernen',
    EditTier: 'Stufe bearbeiten',
    Threshold: 'Empfehlungsanzahl-Schwelle',
    TierOutcome: 'Stufenergebnis',
    TierDisplaySettings: 'Stufen-Anzeigeeinstellungen',
    TierTitle: 'Stufentitel',
    TierSubtitle: 'Stufen-Untertitel',
    TierIcon: 'Stufensymbol',
    UploadCustomIcon: 'Benutzerdefiniertes Symbol hochladen',
    RefereeOutcome: 'Empfänger-Ergebnis',
    EmptyState: 'Keine Stufen konfiguriert. Stufe hinzufügen, um zu beginnen.',
    DuplicateThreshold: 'Eine andere Stufe hat denselben Schwellenwert',
    GameTry: 'Spielversuch',
    CurrentTier: 'Aktuelle Stufe',
    NextTier: 'Nächste Stufe',
    Voucher: 'Gutschein',
    Points: 'Punkte',
    Badge: 'Abzeichen',
    OutcomeType: 'Ergebnistyp',
    Save: 'Speichern',
    Cancel: 'Abbrechen',
    MissingThreshold: 'Schwellenwert ist erforderlich',
    MinThresholdError: 'Schwellenwert muss mindestens 1 sein',
    Rule: 'Regel',
    Actions: 'Aktionen',
    RuleConfigured: 'Regel konfiguriert',
    Title: 'Stufenleiter',
    ReferralsRequired: 'Empfehlungen erforderlich',
    MechanicsTitle: 'Empfehlungsstufen-Mechanik',
    TierName: 'Stufe',
    ThresholdInline: 'GESAMTZAHL DER EMPFEHLUNGEN ZUM ABSCHLIESSEN DIESER STUFE',
    AddRule: 'Regel hinzufügen',
    RuleName: 'Name',
    Prize: 'Preis',
    AddPrize: 'Preis hinzufügen',
    AddRewards: 'Belohnungen hinzufügen',
    AddPoints: 'Punkte hinzufügen',
    AddBadge: 'Abzeichen hinzufügen',
    AddGameTry: 'Spielversuch hinzufügen',
    NoData: 'Keine Daten',
    NoPrizes: 'Kein Preis hinzugefügt',
    TierHeadline: 'Stufen-Überschrift',
    TierSubHeadline: 'Stufen-Unterüberschrift',
    RewardBalance: 'Belohnungssaldo',
    PointsAwarded: 'Vergebene Punkte',
    ReferrerLimits: 'Empfehlergrenzen',
    ReferralsNeeded: 'Erforderliche Empfehlungen',
    RefereeRewardLimit: 'Belohnungslimit für Empfänger'
  },

  [ReferralReportsKey]: {
    InviteEarnSummary: 'Einladen & Verdienen Zusammenfassung',
    InviteEarnBreakdown: 'Einladen & Verdienen Aufschlüsselung',
    AggregatedReferralCountSummary: 'Aggregierte Empfehlungsanzahl Zusammenfassung',
    AggregatedReferralCountBreakdown: 'Aggregierte Empfehlungsanzahl Aufschlüsselung'
  },

  [ReferralAnalyticsKey]: {
    ReferralPerformance: 'Empfehlungsleistung',
    TotalReferrers: 'Empfehler insgesamt',
    TotalReferees: 'Empfänger insgesamt',
    TotalSuccessfulReferrals: 'Gesamte erfolgreiche Empfehlungen',
    ReferralCompletionRate: 'Empfehlungsabschlussrate',
    CustomerEngagementRate: 'Kundenbindungsrate',
    ReferrersPerTier: 'Empfehler pro Stufe',
    OutcomesIssued: 'Ausgegebene Ergebnisse',
    TierColumn: 'Stufe',
    ReferrersColumn: 'Empfehler',
    RefereesColumn: 'Empfänger',
    KeyMetrics: 'Schlüsselkennzahlen',
    TotalSuccessfulReferralsHelp:
      'Gesamtzahl der Empfehlungen, die alle qualifizierenden Aktionen abgeschlossen haben.',
    ReferralCompletionRateHelp:
      'Prozentsatz der gestarteten Empfehlungen, die erfolgreich abgeschlossen wurden.',
    CustomerEngagementRateHelp:
      'Prozentsatz der erreichten Zielgruppe, die mit der Empfehlungskampagne interagiert hat.'
  }
};
